import * as React from 'react';

interface IProps {
  width?: number;
  strokeColor?: string;
  fillColor?: string;
}

export default (props: IProps) => {
  const {width, fillColor, strokeColor} = props;

  return (
    <svg
      width={width}
      height="70"
      viewBox="0 0 70 70"
      fill={fillColor ?? 'none'}
      xmlns="http://www.w3.org/2000/svg">
      <g id="Group 3">
        <circle
          id="Oval"
          cx="35"
          cy="35"
          r="35"
          fill={fillColor ?? '#FF8C00'}
        />
        <path
          id="Vector"
          d="M22 18C23 18 48 18.0006 48 18.0006C49 18 50 18.9 50 19.8V52.3137C50 52.9746 49.5703 53.5723 48.9062 53.8465C48.2422 54.1207 47.4609 54.0223 46.9062 53.5934L43.75 51.1605L40.5938 53.5934C39.8906 54.1348 38.8594 54.1348 38.1562 53.5934L35 51.1605L31.8438 53.5934C31.1406 54.1348 30.1016 54.1348 29.4062 53.5934L26.25 51.1605L23.0938 53.5934C22.5391 54.0223 21.7578 54.1207 21.0938 53.8465C20.4297 53.5723 20 52.9746 20 52.3137V19.8007C20 18.9007 21 18 22 18ZM27.5 28.1258C26.8125 28.1258 26.25 28.6321 26.25 29.2508C26.25 29.8696 26.8125 30.3758 27.5 30.3758H42.5C43.1875 30.3758 43.75 29.8696 43.75 29.2508C43.75 28.6321 43.1875 28.1258 42.5 28.1258H27.5ZM26.25 42.751C26.25 43.3698 26.8125 43.876 27.5 43.876H42.5C43.1875 43.876 43.75 43.3698 43.75 42.751C43.75 42.1323 43.1875 41.626 42.5 41.626H27.5C26.8125 41.626 26.25 42.1323 26.25 42.751ZM27.5 34.8759C26.8125 34.8759 26.25 35.3822 26.25 36.0009C26.25 36.6197 26.8125 37.1259 27.5 37.1259H42.5C43.1875 37.1259 43.75 36.6197 43.75 36.0009C43.75 35.3822 43.1875 34.8759 42.5 34.8759H27.5Z"
          fill={strokeColor ?? 'white'}
        />
      </g>
    </svg>
  );
};
